import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _objectWithoutProperties from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["value", "error", "disabled", "onDelete", "onUpload", "onRemove", "thumbnail", "helperText", "onRemoveAll", "multiple", "enablePreview", "maxFiles", "currentNumberOfFiles", "accept", "placeholder", "multiFilePlaceholder", "maxSize"];
var __jsx = React.createElement;
import { useDropzone } from "react-dropzone";
import styles from "./styles/upload.module.css";
import UploadPlaceholder from "@/components/Upload/components/UploadPlaceholder";
import MultiFilePreview from "@/components/Upload/components/MultiFilePreview";
import MultiFileUploadPlaceholder from "@/components/Upload/components/MultiFileUploadPlaceholder";
import React from "react";
import { getErrorMessage } from "@/components/Upload/utils/upload-error-codes";
import { useTranslation } from "@i18n";
var Upload = function Upload(_ref) {
  var value = _ref.value,
    error = _ref.error,
    disabled = _ref.disabled,
    onDelete = _ref.onDelete,
    onUpload = _ref.onUpload,
    onRemove = _ref.onRemove,
    thumbnail = _ref.thumbnail,
    helperText = _ref.helperText,
    onRemoveAll = _ref.onRemoveAll,
    _ref$multiple = _ref.multiple,
    multiple = _ref$multiple === void 0 ? false : _ref$multiple,
    _ref$enablePreview = _ref.enablePreview,
    enablePreview = _ref$enablePreview === void 0 ? false : _ref$enablePreview,
    _ref$maxFiles = _ref.maxFiles,
    maxFiles = _ref$maxFiles === void 0 ? 2 : _ref$maxFiles,
    _ref$currentNumberOfF = _ref.currentNumberOfFiles,
    currentNumberOfFiles = _ref$currentNumberOfF === void 0 ? 0 : _ref$currentNumberOfF,
    _ref$accept = _ref.accept,
    accept = _ref$accept === void 0 ? {
      "image/*": [".jpeg", ".jpg", ".png"],
      "application/pdf": [".pdf"]
    } : _ref$accept,
    placeholder = _ref.placeholder,
    multiFilePlaceholder = _ref.multiFilePlaceholder,
    _ref$maxSize = _ref.maxSize,
    maxSize = _ref$maxSize === void 0 ? 5e+6 : _ref$maxSize,
    other = _objectWithoutProperties(_ref, _excluded);
  var _useDropzone = useDropzone(_objectSpread({
      multiple: multiple,
      accept: accept,
      disabled: disabled,
      maxFiles: maxFiles,
      onDrop: onUpload,
      maxSize: maxSize
    }, other)),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps,
    isDragActive = _useDropzone.isDragActive,
    isDragReject = _useDropzone.isDragReject;
  var isArray = Array.isArray(value) && multiple;
  var hasFile = isArray && !!value; // Single file uploaded
  var hasFiles = isArray && !!value.length; // Multiple files uploaded
  var hasError = isDragReject || !!error;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var renderPreview = function renderPreview() {
    if (hasFiles) {
      return /*#__PURE__*/React.createElement(MultiFilePreview, {
        files: value,
        onRemove: onRemove,
        enablePreview: enablePreview
      });
    }
    if (hasFile) {
      return (
        /*#__PURE__*/
        //@FIXME: should be used for single file upload
        // <SingleFilePreview
        //     file={value as File}
        //     onRemove={onDelete}
        //     enablePreview={enablePreview}
        // />
        React.createElement(MultiFilePreview, {
          files: value,
          onRemove: onRemove,
          enablePreview: enablePreview
        })
      );
    }
    return null;
  };
  var renderPlaceholder = function renderPlaceholder() {
    if (multiple && hasFiles) {
      return /*#__PURE__*/React.createElement(MultiFileUploadPlaceholder, {
        placeholder: multiFilePlaceholder
      });
    }
    return /*#__PURE__*/React.createElement(UploadPlaceholder, {
      placeholder: placeholder
    });
  };
  var renderInput = function renderInput() {
    if (!hasFile && currentNumberOfFiles < maxFiles || multiple) {
      return /*#__PURE__*/React.createElement("input", getInputProps());
    }
    return null;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles.uploadContainer
  }, renderPreview(), (currentNumberOfFiles < maxFiles || !hasFile) && /*#__PURE__*/React.createElement("div", _extends({}, getRootProps(), {
    className: "".concat(styles.dropzone, "\n            ").concat(isDragActive ? styles.dragActive : "", "\n            ").concat(disabled ? styles.disabled : "", "\n            ").concat(hasError ? styles.error : "", "\n            ").concat(multiple && hasFiles ? styles.hasMultiple : "", "\n          ")
  }), renderInput(), (!hasFile || multiple) && renderPlaceholder()), (error === null || error === void 0 ? void 0 : error.code) && /*#__PURE__*/React.createElement("div", {
    className: styles.errorText
  }, tShort(getErrorMessage(error.code), {
    ns: "validations"
  })), (error === null || error === void 0 ? void 0 : error.message) && !error.code && /*#__PURE__*/React.createElement("div", {
    className: styles.errorText
  }, tShort(error.message, {
    ns: "validations"
  })));
};
export default Upload;